import dialog from './Dialog';
import dataLayerPush from './DataLayer';

export default function addProductToCart({
  title,
  code,
  category,
  minQty,
  stock,
  step,
  wholesale,
  salePrice,
}: {
  title: string,
  code: string,
  category: string,
  minQty: number,
  stock: number,
  step: number,
  wholesale: Array<{ fromQuantity: number, price: number }>,
  salePrice: number,
}) {
  function limitQty(currentQty: number): number {
    return Math.round((Math.min(Math.max(currentQty, minQty), stock)) * (1 / step)) / (1 / step);
  }

  return {
    ...dialog(),

    submitting: false,
    timestamp: Date.now(),
    qty: 1,
    min: minQty,
    max: stock,
    step,
    wholesale,
    salePrice,

    handleInit() {
      dataLayerPush({
        event: 'view_item',
        ecommerce: {
          send_to: 'GA4',
          currency: 'EUR',
          value: salePrice,
          items: [{
            item_brand: 'Driessen stoffen',
            item_name: title,
            item_id: code,
            item_category: category,
            price: salePrice,
          }],
        },
      });
    },

    handleQtyIncrease() {
      this.qty = limitQty((this.qty || 0) + 1);
    },

    handleQtyDecrease() {
      this.qty = limitQty((this.qty || 0) - 1);
    },

    handleQtyKeyDown(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        (event.target as HTMLInputElement).blur();
      }
    },

    handleQtyBlur() {
      if (!this.qty) {
        return;
      }

      this.qty = limitQty(this.qty || 0);
    },

    handleSubmit(event: FormDataEvent) {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      dataLayerPush({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          value: this.total(),
          items: [{
            item_brand: 'Driessen stoffen',
            item_name: title,
            item_id: code,
            item_category: category,
            price: salePrice,
          }],
        },
        eventTimeout: 2000,
      });

      const form = event.target as HTMLFormElement;
      fetch('/', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'manual',
      })
        .then(() => {
          this.submitting = false;
          // @ts-ignore
          htmx.trigger('#account-menu', 'refresh');
          // @ts-ignore
          htmx.trigger('#account-menu-mobile', 'refresh');
          this.openSuccessDialog();
        })
        .catch(() => {
          this.submitting = false;
        });
    },

    resetForm() {
      this.qty = Math.max(minQty, 1);
      this.timestamp = Date.now();
    },

    openSuccessDialog() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
    },

    closeSuccessDialog() {
      this.resetForm();
      this.open = false;
      document.body.style.overflowY = 'initial';
    },

    total() {
      let currentSalePrice = this.salePrice;
      wholesale.forEach((row) => {
        if ((this.qty || 0) >= row.fromQuantity) {
          currentSalePrice = row.price;
        }
      });

      const total = (this.qty || 0) * currentSalePrice;
      return parseFloat(total.toFixed(2));
    },

    totalFormatted() {
      return Craft.formatCurrency(this.total());
    },
  };
}
